export const iconMap: Record<string, string> = {
    plusBlack: "plus",
    barChartBlack: "barChart",
    boxBlack: "box",
    trendingUpBlack: "trendingUp",
  };
  
  export const reverseIconMap: Record<string, string> = {
    plus: "plusBlack",
    barChart: "barChartBlack",
    box: "boxBlack",
    trendingUp: "trendingUpBlack",
  };
  